// extracted by mini-css-extract-plugin
module.exports = {"success":"Success_success__pl5fH","icon":"Success_icon__GXxvE","info":"Success_info__3ud85","price":"Success_price__Mnhgr","text":"Success_text__2UHpi"};